<div class="px-3 md:px-5 2xl:px-28 3xl:px-52">
  <div class="container mx-auto">
    <div class="flex border-b justify-between items-center py-5">
      <div>
        <h1 class="text-xl font-semibold md:leading-[48.41px] md:text-3xl">
          My Dashboard
        </h1>
        <p *ngIf="user$ | async as user" class="md:text-xl">
          Welcome, {{ user['https://onlyusedtesla.com/firstName'] }}
        </p>
      </div>
      <div class="flex justify-center gap-3 items-center">
        <div
          *ngIf="user$ | async as user"
          class="h-fit p-2 text-white w-fit font-semibold"
        >
          <img
            class="rounded-full"
            [src]="
              'https://ui-avatars.com/api/?background=1466c9&color=fff&name=+' +
              user['https://onlyusedtesla.com/firstName']
            "
            alt=""
          />
        </div>
      </div>
    </div>

    <div
      class="bg-[url('/assets/images/dashboard-banner.jpg')] h-[250px] bg-cover bg-center flex justify-center items-center my-7 p-3 rounded-lg shadow-sm"
    >
      <div class="flex flex-col justify-center banner-text items-center">
        <h2
          class="text-2xl text-center text-white font-semibold mb-4 md:leading-[48.41px] md:mb-0 md:text-3xl"
        >
          Add New Tesla Listing
        </h2>
        <button
          [routerLink]="['/your-tesla']"
          class="bg-[#1466C9] rounded-full text-sm text-white w-fit cursor-pointer font-semibold px-5 py-3"
        >
          Add New Listing
        </button>
      </div>
    </div>

    <div *ngIf="isLoading">
      <div class="flex justify-start gap-4 items-center mb-7">
        <span
          class="bg-[#e1e5e8] h-[30px] rounded-sm w-[200px] relative skeleton-shimmer"
        >
        </span>
        <span
          class="bg-[#e1e5e8] h-[30px] rounded-sm w-[200px] relative skeleton-shimmer"
        >
        </span>
      </div>
      <div
        class="grid w-full gap-4 md:grid-cols-2 xl:gap-x-7 xl:gap-y-10 xl:grid-cols-3"
      >
        <div *ngFor="let _ of [1, 2, 3, 4, 5, 6, 7, 8, 9]">
          <out-listing-skeleton></out-listing-skeleton>
        </div>
      </div>
    </div>

    <div *ngIf="!isLoading">
      <!-- Tabs -->
      <nav
        class="flex border-b border-gray-300 justify-start mb-7 mt-5 no_scrollbar overflow-x-auto"
      >
        <button
          *ngFor="let tab of tabs"
          (click)="setActiveTab(tab.id)"
          class="flex text-nowrap duration-300 font-semibold gap-2 items-center px-4 py-2 relative transition-all cursor-pointer"
          [class.text-blue-600]="isTabActive(tab.id)"
          [class.text-[#7E7E7ECC]]="!isTabActive(tab.id)"
        >
          {{ tab.label }}

          <!-- Count Pill -->
          <span
            *ngIf="tab.count !== undefined"
            class="justify-center rounded-full text-sm duration-300 font-medium inline-flex items-center px-2.5 py-1.5 transition-colors"
            [class.bg-blue-100]="isTabActive(tab.id)"
            [class.text-blue-700]="isTabActive(tab.id)"
            [class.bg-gray-100]="!isTabActive(tab.id)"
            [class.text-gray-600]="!isTabActive(tab.id)"
          >
            {{ tab.count }}
          </span>

          <!-- Active Indicator -->
          <span
            class="bg-blue-600 h-1 w-full absolute bottom-0 duration-300 left-0 scale-x-100 transition-transform"
            *ngIf="isTabActive(tab.id)"
          ></span>
        </button>
      </nav>

      <!-- Tab Content -->
      <div [ngSwitch]="activeTab" class="pb-24">
        <div *ngSwitchCase="'live'">
          <div>
            <!-- Live Listings Grid -->
            <div
              *ngIf="liveListings.length > 0; else noLiveListings"
              class="grid grid-cols-1 gap-6 lg:grid-cols-3 md:grid-cols-2"
            >
              <out-listing-card
                *ngFor="let listing of liveListings"
                [listing]="listing"
                [allowEdit]="true"
              ></out-listing-card>
            </div>

            <!-- Empty State for Live Listings -->
            <ng-template #noLiveListings>
              <div class="bg-gray-50 rounded-lg text-center py-32 lg:py-40">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="text-gray-400 mb-4 mx-auto size-12"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2M9 5h6m-3 4v6m-2-2h4"
                  />
                </svg>
                <h3 class="text-gray-900 text-lg font-medium mb-1">
                  No Live Listings
                </h3>
                <p class="text-gray-500">
                  You don't have any active listings at the moment.
                </p>
              </div>
            </ng-template>
          </div>
        </div>

        <div *ngSwitchCase="'draft'">
          <div>
            <!-- Draft Listings Grid -->
            <div
              class="bg-yellow-600/5 text-yellow-600 px-4 py-3 border border-yellow-600 flex justify-start items-center gap-3 mb-10 rounded-lg font-medium"
            >
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="far"
                data-icon="exclamation-triangle"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
                class="size-5"
              >
                <path
                  fill="currentColor"
                  d="M248.747 204.705l6.588 112c.373 6.343 5.626 11.295 11.979 11.295h41.37a12 12 0 0 0 11.979-11.295l6.588-112c.405-6.893-5.075-12.705-11.979-12.705h-54.547c-6.903 0-12.383 5.812-11.978 12.705zM330 384c0 23.196-18.804 42-42 42s-42-18.804-42-42 18.804-42 42-42 42 18.804 42 42zm-.423-360.015c-18.433-31.951-64.687-32.009-83.154 0L6.477 440.013C-11.945 471.946 11.118 512 48.054 512H527.94c36.865 0 60.035-39.993 41.577-71.987L329.577 23.985zM53.191 455.002L282.803 57.008c2.309-4.002 8.085-4.002 10.394 0l229.612 397.993c2.308 4-.579 8.998-5.197 8.998H58.388c-4.617.001-7.504-4.997-5.197-8.997z"
                  class=""
                ></path>
              </svg>
              <p>
                Draft listings with all required steps completed, including vehicle details, images, and checkout, will be reviewed and published within 24 hours.
              </p>
            </div>
            <div
              *ngIf="draftListings.length > 0; else noDraftListings"
              class="grid grid-cols-1 gap-6 lg:grid-cols-3 md:grid-cols-2"
            >
              <out-listing-card
                *ngFor="let listing of draftListings"
                [listing]="listing"
                [allowEdit]="true"
              ></out-listing-card>
            </div>

            <!-- Empty State for Draft Listings -->
            <ng-template #noDraftListings>
              <div class="bg-gray-50 rounded-lg text-center py-32 lg:py-40">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="text-gray-400 mb-4 mx-auto size-12"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 5v14m-7-7h14M5 12a7 7 0 1 0 14 0a7 7 0 0 0-14 0"
                  />
                </svg>
                <h3 class="text-gray-900 text-lg font-medium mb-1">
                  No Draft Listings
                </h3>
                <p class="text-gray-500">
                  Start creating a new listing to see it here.
                </p>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
